import { render, staticRenderFns } from "./DevRequirementExt copy.vue?vue&type=template&id=fad8dfae&scoped=true"
import script from "./DevRequirementExt copy.vue?vue&type=script&lang=js"
export * from "./DevRequirementExt copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad8dfae",
  null
  
)

export default component.exports